import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
interface OptionPriceSummaryProps {
  totalAmount: number;
  className?: string;
  priceClassName?: string;
}
export const OptionPriceSummary = t0 => {
  const $ = _c(13);
  const {
    totalAmount,
    className,
    priceClassName
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex items-center justify-between py-8", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="font-700 text-Gray-900 typo-body3">선택 금액</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== priceClassName) {
    t3 = cn("font-700 text-Gray-black typo-body1", priceClassName);
    $[3] = priceClassName;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== totalAmount) {
    t4 = totalAmount.toLocaleString();
    $[5] = totalAmount;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <span className={t3}>{t4}원</span>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t5) {
    t6 = <div className={t1}>{t2}{t5}</div>;
    $[10] = t1;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};